// extracted by mini-css-extract-plugin
export var content = "_p5-1";
export var fullScreen = "_p5-0";